import { render, staticRenderFns } from "./leftItem.vue?vue&type=template&id=0b402194"
import script from "./leftItem.vue?vue&type=script&lang=js"
export * from "./leftItem.vue?vue&type=script&lang=js"
import style0 from "./leftItem.vue?vue&type=style&index=0&id=0b402194&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports